import { createSlice } from '@reduxjs/toolkit';
import { emptyFormState } from '../emptyState';
import { postStatus } from '../status';
import { postSetPassword } from 'api';

// Then, handle actions in your reducers:
const setPasswordSlice = createSlice({
  name: 'setPassword',
  emptyFormState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    setPasswordPostStart: (state) => {
      state.status = postStatus.POST_START;
      state.fetching = true;
      state.error = false;
    },
    setPasswordPostSuccess: (state, { payload }) => {
      state.status = postStatus.POST_SUCCESS;
      state.payload = payload;
      state.fetching = false;
      state.error = false;
    },
    setPasswordPostFail: (state, { payload }) => {
      state.status = postStatus.POST_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    setPasswordFormReset: (state) => {
      state.status = null;
      state.payload = null;
      state.fetching = false;
      state.error = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  setPasswordPostStart,
  setPasswordPostSuccess,
  setPasswordPostFail,
  setPasswordFormReset,
} = setPasswordSlice.actions;

// The reducer
export const setPasswordReducer = setPasswordSlice.reducer;

// Asynchronous thunk action
export const setPasswordPost = (formData) => (dispatch) => {
  dispatch(setPasswordPostStart());

  postSetPassword(formData)
    .then((payload) => {
      dispatch(setPasswordPostSuccess(payload));
    })
    .catch((error) => {
      dispatch(setPasswordPostFail(error));
    });
};
